// 폭 구간(DESIGN §5 · tokens.json breakpoints 0/600/840/1200)과 해시 라우팅(#/… 고정)
import { useEffect, useState, useSyncExternalStore } from "react";

export type WidthClass = "compact" | "medium" | "expanded" | "large";
const MQ = {
  medium: "(min-width: 600px)",
  expanded: "(min-width: 840px)",
  large: "(min-width: 1200px)",
  low: "(max-height: 699px)",
};

function readWidth(): WidthClass {
  if (matchMedia(MQ.large).matches) return "large";
  if (matchMedia(MQ.expanded).matches) return "expanded";
  if (matchMedia(MQ.medium).matches) return "medium";
  return "compact";
}

function subscribeMq(f: () => void) {
  const qs = Object.values(MQ).map((q) => matchMedia(q));
  qs.forEach((q) => q.addEventListener("change", f));
  return () => qs.forEach((q) => q.removeEventListener("change", f));
}

export const useWidthClass = () => useSyncExternalStore(subscribeMq, readWidth);
export const useLowHeight = () => useSyncExternalStore(subscribeMq, () => matchMedia(MQ.low).matches);

export type Route = { name: string; param: string | null; query: URLSearchParams; raw: string };

function parse(): Route {
  const raw = window.location.hash.replace(/^#\/?/, "");
  const [path, qs] = raw.split("?");
  const [name, param] = path.split("/");
  return { name: name || "", param: param ? decodeURIComponent(param) : null, query: new URLSearchParams(qs || ""), raw };
}

export function useRoute(): Route {
  const [r, setR] = useState(parse);
  useEffect(() => {
    const on = () => setR(parse());
    window.addEventListener("hashchange", on);
    return () => window.removeEventListener("hashchange", on);
  }, []);
  return r;
}

export function go(path: string) {
  const h = "#/" + path.replace(/^#?\/?/, "");
  if (window.location.hash !== h) window.location.hash = h;
}

/** localStorage 에 기억하는 작은 화면 설정(레일 펼침·당일 보기 방식 등) */
export function usePref<T extends string>(key: string, def: T): [T, (v: T) => void] {
  const [v, setV] = useState<T>(() => {
    try {
      return (localStorage.getItem(key) as T) || def;
    } catch {
      return def;
    }
  });
  const set = (nv: T) => {
    setV(nv);
    try { localStorage.setItem(key, nv); } catch { /* 무시 */ }
  };
  return [v, set];
}
